import TaskExpertFeedbackModule from './task-expert-feedback.module'

export default TaskExpertFeedbackModule
